import { useNotificationStore } from '~/stores/notification'
export function addNotification({
  type,
  message,
  statusCode,
}: {
  type: string
  message: string
  statusCode?: number
}) {
  const notification = {
    type,
    statusCode: statusCode ?? 0,
    message,
  }
  console.debug(`[cynqueModules/queueNotification.js] queueNotification...`)
  console.debug(notification)
  useNotificationStore().add(notification)
}
